import { DeleteIcon, EditIcon, LabeledIcon } from 'components/Icon';
import React from 'react';
import { useHistory } from 'react-router';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { RequesterToken } from 'stores/RequesterTokenStore';
import { DefaultCopyToClipboard } from 'components/CopyToClipboard';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  requesterToken: RequesterToken,
}

export const ViewForm: React.FC<Props> = ({requesterToken}: Props) =>
{
  const history = useHistory();
  const { uiStore, requesterTokenStore } = useStore();

  const locationState = history.location.state as { isCancelRequired: boolean };

  const editRequesterTokenHandler = () => history.push(paths.buildRequesterTokenEditPath(requesterToken.token || ''));
  const createRequesterTokenHandler = () => history.push(paths.buildRequesterTokenCreatePath());
  const toListHandler = () => history.push(paths.buildRequesterTokenListPath());
  const cancelHandler = () =>
  {
    requesterTokenStore.requesterToken.clearError();
    history.goBack();
  };
  const deleteRequesterTokenHandler = async () =>
  {
    if (window.confirm(uiStore.labels.pages.audience.deleteRequesterTokenConfirmation.apply({requesterToken: requesterToken.token})))
    {
      await requesterTokenStore.deleteAsync(requesterToken.token || '');
      if (!requesterTokenStore.requesterToken.isError)
      {
        history.push(paths.buildRequesterTokenListPath());
      }
    }
  };
  return (
    <>
      <div className="fields">
        <label>
          {uiStore.labels.common.forms.requesterToken.token.label}:<SimpleInlineHelp>{uiStore.labels.help.audience.requester_tokens.token.about}</SimpleInlineHelp>
          <DefaultCopyToClipboard text={requesterToken.token} />
          <input type="text" value={requesterToken.token} readOnly={true} />
        </label>
        <label>
          {uiStore.labels.common.forms.requesterToken.requester.label}:
          <input type="text" value={requesterToken.requester?.name} readOnly={true} />
        </label>

        <div className="info">
          <p>{uiStore.labels.common.forms.requesterToken.createdBy.apply({by: requesterToken.created_by, at: new Date(Date.parse(requesterToken.created_at || '')).toLocaleString(),})}</p>
          <p>{uiStore.labels.common.forms.requesterToken.updatedBy.apply({by: requesterToken.updated_by, at: new Date(Date.parse(requesterToken.updated_at || '')).toLocaleString(),})}</p>
        </div>
      </div>

      <div className="actions">
        <button onClick={editRequesterTokenHandler}><LabeledIcon label={uiStore.labels.common.forms.edit}><EditIcon /></LabeledIcon></button>
        <button onClick={deleteRequesterTokenHandler}><LabeledIcon label={uiStore.labels.common.forms.delete}><DeleteIcon/></LabeledIcon></button>
        <button onClick={createRequesterTokenHandler}>{uiStore.labels.common.forms.createAnother}</button>
        {
          locationState?.isCancelRequired
          ? <button onClick={cancelHandler}>{uiStore.labels.common.forms.cancel}</button>
          : <button onClick={toListHandler}>{uiStore.labels.common.forms.toList}</button>
        }
      </div>
    </>
  );
};